
const URL = 'https://static.h.ai/assets/landing-page/'

export const staticSrc = (name, ext='jpg') => (
  `${URL}${name}.${ext}`)

export const staticSrcSet = (name, ext='jpg') => (
  `${URL}${name}@2x.${ext} 2x, ${URL}${name}@3x.${ext} 3x`)
